<template>
  <v-layout
    row
    wrap
    align-center
    justify-center
    fill-height
    :class="{'mt-3':$vuetify.breakpoint.smAndUp,'mt-1':$vuetify.breakpoint.xsOnly}"
  >
    <v-flex
      xs12
      class="text-xs-center"
    >
      <span class="title">{{ $t('message.bizgainOnboarding.profileReady') }}</span>
    </v-flex>
    <v-flex
      xs10
      class="text-xs-center"
      :class="{'mt-3':$vuetify.breakpoint.smAndUp,'mt-2':$vuetify.breakpoint.xsOnly}"
    >
      <span class="body-1 grey--text">{{ $t('message.bizgainOnboarding.detailsCapturedMessage') }}</span>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex
} from 'vuetify/lib';
import { mapActions, mapGetters  } from 'vuex';
import delay from 'lodash/delay';
import { bizgainOnboardingRoutes, tickAnimationInterval, launchState } from 'Features/bizgainOnboarding/constants';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
export default {
  mixins: [onboardingRedirect],
  components: {
    VLayout,
    VFlex
  },
  data(){
    return{
      bizgainOnboardingRoutes
    }
  },
  computed: {
    ...mapGetters(['businessDetails'])
  },
  created(){
    this.setCurrentRoute(bizgainOnboardingRoutes.BusinessDetailsAnimation.name);
    delay(this.goToNextPage, tickAnimationInterval);
  },
  methods: {
    ...mapActions(['patchBusinessDetails', 'setCurrentRoute']),
    async goToNextPage(){
      this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      await this.redirect({ isAppFlow: true }, {}, false, launchState.OBJECTIVE, this.newBusinessDetails);
    }
  }
}
</script>